import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-invoice-error-banner',
  templateUrl: './invoice-error-banner.component.html',
  styleUrls: ['./invoice-error-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceErrorBannerComponent {
  @Input() message: string | null = null;

  protected readonly fallbackMessage =
    'Verifique os dados da venda e tente emitir novamente.';
}
